/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type HandlingOperatorVehicleFragment = {
  __typename?: 'Vehicle'
  fccHandledBy: Array<{
    __typename?: 'FccVehicleHandledBy'
    role: Types.FccOperatorRoleType
    backofficeUserId: string
    backofficeUser: {
      __typename?: 'BackofficeUser'
      firstName: string
      lastName: string
    } | null
  }>
  fccHandledByOperator: { __typename?: 'BackofficeUser'; id: string } | null
  fccHandledByOperatorDetails: {
    __typename?: 'BackofficeUser'
    firstName: string
    lastName: string
  } | null
}

export const HandlingOperatorVehicleFragmentDoc = gql`
    fragment HandlingOperatorVehicle on Vehicle {
  fccHandledBy {
    role
    backofficeUserId
    backofficeUser {
      firstName
      lastName
    }
  }
  fccHandledByOperator {
    id
  }
  fccHandledByOperatorDetails: fccHandledByOperator {
    firstName
    lastName
  }
}
    `
